import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody, Badge, ButtonGroup, Popover, PopoverBody, PopoverHeader} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Modal from './Modal';
import * as TextManager from "../../../modules/languages/TextManager";
import {withStyles} from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';

import {
    eq_order_delete,
    eq_order_open_update_form, fetchEquipmentDataForce
} from "../../../redux/actions/EquipmentActions";

import EquipOrderManageJson from './EquipOrderManageJson'
import arrayToCsv from "../../../modules/arrayToCsv";



const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class EquipmentTableOrdersJson extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            deals: [],
            selectedID: '0',
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 10,
            popoverOpen: 0
        };
    }

    componentDidMount() {
        //window.setInterval(this.refreshPage, 5000);
    }

    editOrder = (order) => {
        if (order.id === this.state.selectedID) {
            this.setState({selectedID: 0});
        } else {
            this.props.dispatch(eq_order_open_update_form(order));
            this.setState({selectedID: order.id});
        }
    };

    deleteOrderEq = (order) => {

        order.isStore = this.props.stores ? 1 : 0;

        //abc
        http.postToServer(
            'equip/equip_order_delete', //'equip/equip_order_delete?id=' + customer.id + '&isManager=' + managerName + '&managerName=' + customer.managerName,
            order,
            (response) => {
                this.props.dispatch(eq_order_delete(order.id));

                this.props.dispatch(fetchEquipmentDataForce(this.queryParams));
            },
            (response) => {
                console.log('error delete orders');
            }
        );
    };

    togglePopover = (id) => {

        //console.log("togglePopover")

        if(this.state.popoverOpen !== 0) {
            this.setState({popoverOpen: 0});
        }
        else {
            this.setState({popoverOpen: id});
        }
    };

    getRow(order, index, isAdmin) {

        let status = order.provided === 0 ? 'לא סופקה' : 'סופקה הסחורה';
        let color = order.provided === 0 ? 'warning' : 'success';

        /*if (order.provided !== 0) {
            status = TextManager.getCurrentTextResource().Text.active;
            color = 'success';
        } else  {
            status = TextManager.getCurrentTextResource().Text.new;
            color = 'warning';
        }*/

        let colorAcc = order.account === 0 ? 'warning' : 'success';
        let payType = "";

        switch (order.payment.payType) {
            case 0: payType = 'התחשבנות'; break;
            case 1: payType = 'כרטיס אשראי'; break;
            case 2: payType = 'צ\'\'ק'; break;
            default: payType = 'התחשבנות'; break;
        }

        return (

            <React.Fragment key={order.id}>

                <tr key={order.id} style={{cursor: 'pointer'}} onClick={() => this.editOrder(order)}>

                    {isAdmin && <td>
                        <Modal color='danger' title='Are you sure!'
                               approve={() => this.deleteOrderEq(order)}
                               message={'Delete Order ' + order.equipName + '?'}>
                            <Button color='danger' size='sm' onClick={(e) => e.preventDefault()}
                                    style={{padding: "0px 15px"}}>
                                <FontAwesome name='times'/>
                            </Button>

                        </Modal>
                    </td>}

                    {isAdmin && this.props.stores && <td>
                        <Badge color={colorAcc}>{payType}</Badge>
                    </td>}

                    <td>
                        <Badge color={color}>{status}</Badge>
                    </td>

                    {/*<td>{order.serialNum}</td>
                    <td>{order.text}</td>*/}
                    <td>{isAdmin && order.managerName !== "" && <i id={"PopoverManager"+order.id} className="fa fa-question-circle-o"
                                                           style={{ fontSize: '18px', marginRight: '8px', cursor: 'pointer'}}
                                                           onClick={(e) =>
                                                           {
                                                               e.stopPropagation();
                                                               this.togglePopover(order.id)}
                                                           }></i>}
                        {isAdmin && order.managerName !== "" && <Popover
                            placement="top"
                            isOpen={this.state.popoverOpen === order.id}
                            target={"PopoverManager" + order.id}
                            toggle={() => this.togglePopover(0)}
                        >
                            <PopoverHeader>שם מנהל</PopoverHeader>
                            <PopoverBody>{order.managerName}
                            </PopoverBody>
                        </Popover>}
                        {order.storeName}
                    </td>
                    <td>{order.updateDate}</td>
                    <td>{order.date}</td>

                </tr>

                {order.id === this.state.selectedID &&
                <tr key={order.id + 2000}>
                    <td colSpan="12" style={{backgroundColor: 'aliceblue'}}>
                        <EquipOrderManageJson order={order} managers={this.props.managers} onClose={() => {
                            this.setState({selectedID: 0});
                        }}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    handleDownload = () => {
        let dataTmp = this.props.data;
        let data = [];

        if (dataTmp.length > 0) {
            let filterNames = Object.getOwnPropertyNames(dataTmp[0]);
            if (filterNames.includes('orders')) {
                for (let indx in dataTmp) {
                    for (let indx2 in dataTmp[indx].orders) {

                        let obj = {...dataTmp[indx]};

                        let price = "";

                        for(let i in this.props.equip) {
                            //for(let y in this.props.equip[i].data) {

                                //console.log(this.props.equip[i].data[y])

                                let euipEntity = this.props.equip[i].data.find(e => e.id === dataTmp[indx].orders[indx2].equipId);

                                if (euipEntity !== undefined) {
                                    price = parseFloat(euipEntity.price) + parseFloat(euipEntity.price) * (parseFloat(euipEntity.profit) * 0.01);
                                    break;
                                }
                            //}
                        }

                        obj.orders = dataTmp[indx].orders[indx2].equipName + " כמות- " + dataTmp[indx].orders[indx2].storeOrderNums + "  מחיר- " + price;

                        data.push(obj);
                    }
                }
            } else {
                data = dataTmp;
            }

            let csvContent = arrayToCsv({
                data,
                translated: {
                    ...TextManager.getCurrentTextResource().Customers,
                },
                boolTotext: ['account'],
                excludeKey: ['lines', 'updateDate']
            });

            let link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
            link.setAttribute("download", "download.csv");
            link.click();
        }

    };


    render() {

        const {rowsPerPage, page} = this.state;

        const isDelete = this.props.userData && this.props.userData.data.isAdmin;

        let isStore = true;
        if (this.props.userData && this.props.userData.data &&
            (this.props.userData.data.isAdmin || this.props.userData.data.isManager)) {
            isStore = false;
        }

        let isManager = false;
        if (this.props.userData && this.props.userData.data &&
            (this.props.userData.data.id === 548 || this.props.userData.data.id === 683 || this.props.userData.data.id === 1007)) {
            isManager = true;
        }

        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && (this.props.userData.data.isAdmin || this.props.userData.data.id === 795)) {
            isAdmin = true;
        }


        /*let data = [];
        if(this.props.data) {
            data = this.props.data;
        }*/

        let data = [];

        if(this.props.data && this.props.data.equipOrders) {

            //console.log(this.props.data.equipOrders)
            if(isStore) {
                data = this.props.data.equipOrders.filter(e => e.storeId === this.props.userData.data.id);
            }
            else if(isManager) {
                data = this.props.data.equipOrders;
            }
            else {

                if(this.props.stores) {
                    data = this.props.data.equipOrders.filter((e) => (e.storeId !== 31 && e.storeId !== 118 && e.storeId !== 548 && e.storeId !== 683 && e.storeId !== 1007));
                }
                else if(this.props.managers) {
                    data = this.props.data.equipOrders.filter((e) => (e.storeId === 31 || e.storeId === 118 || e.storeId === 548 || e.storeId === 683 || e.storeId === 1007));
                }
            }
        }


        /*let rows = data.map((item, index) =>
            this.getRow(item, index, isAdmin));*/

        let rows = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) =>
            this.getRow(item, index, isAdmin));

        return (
            <Card>
                <CardBody>
                        <span>
                            <Table responsive className='table-hover table--bordered'>
                                <thead>
                                <tr>
                                    {isDelete && <th></th>}
                                    {isAdmin && this.props.stores && <th>צורת תשלום</th>}
                                    <th>{TextManager.getCurrentTextResource().Customers.status}</th>
                                    <th>שם חנות</th>
                                    <th>{TextManager.getCurrentTextResource().Orders.updateDay}</th>
                                    <th>{TextManager.getCurrentTextResource().Orders.day}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </Table>
                            <Row>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <CustomPagination
                                        labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                        rowsPerPageOptions={[5, 10, 20]}
                                        component="div"
                                        count={data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </Col>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <ButtonGroup className='btn-group--icons'
                                                 style={{marginTop: "10px", float: "right"}}>
                                        <Button outline color='primary'
                                                onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </span>
                </CardBody>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.equipment.status,
        data: state.equipment.data,
        equip: state.equipment.data.equip,
        userData: state.userData,
        providers: state.sales.data,
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentTableOrdersJson))